import "./ChatInputBar.css";
import { trackEvent , getUserKb, getDeployment } from "../../../Actions/Utils";
import { doubt } from "../../../NewConstants/ChatConstants";
import { deploymentNeGD } from "../../../NewConstants/DeploymentConstants";

const ChatInputBar = ({
  selectedLanguage,
  textareaRef,
  optionSelected,
  input,
  setInput = () => {},
  send = () => {},
  adjustTextareaHeight = () => {},
  textSize,
  isLoading,
  selectedDocument,
  optionClicked,
  setOptionSelected = () => {},
  setOptionClicked = () => {},
}) => {
  const isIframe = getDeployment() === deploymentNeGD;

  function toggleOptionSelected() {
      setOptionSelected(!optionSelected);
      setOptionClicked(!optionClicked);
    trackEvent("Default Chips", "Click", "Default chips menu");
  }
  function sendText() {
    if (!isLoading && input.length > 0) {
      send(-1, input, true, null);
      setInput("");
      adjustTextareaHeight(true);
    }
  }

  return (
    <div className="bg-[--neutral-white] w-100 flex items-center justify-start min-h-[3.25rem] rounded-full chatInputBarDiv">
      <div onClick={toggleOptionSelected} className="flex items-center h-full pl-3" >
        <img
          id="tour-grid-button"
          src={
            optionSelected
              ?  isIframe ? "/Assets/Images/GridSelectedRed.svg" : "/Assets/Images/InputImageSelected.svg"
              : isIframe ? "/Assets/Images/GridRed.svg" : "/Assets/Images/InputImage.svg"
          }
          alt="User Input"
          className="h-[1.75rem]"
        />
      </div>
      <div className="inputDivider h-[70%]" />
      <textarea
        id="tour-input-bar"
        ref={textareaRef}
        rows="1"
        placeholder={
          getUserKb() === 'GHS' ? selectedDocument
            ? `Ask your query from ${selectedDocument}`
            : `Please Select module to ask` : (doubt[selectedLanguage])
        }

        className="flex-1 chat-input p-2 rounded-l-xl mt-1 mb-1 rounded-r-full outline-none resize-none placeholder:italic placeholder:text-base"
        value={input}
        disabled={getUserKb() === 'GHS' && !selectedDocument}
        onChange={(event) => {
          setInput(event.target.value);
          event.target.value.length > 0
            ? adjustTextareaHeight()
            : adjustTextareaHeight(true);
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            sendText();
          }
        }}
        style={{
          fontSize: `${textSize}rem`,
        }}
        name="inputBar"
      />
    </div>
  );
};

export default ChatInputBar;
